// components/SplashScreenWeb.jsx
import React from 'react';

export default function SplashScreenWeb() {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-light text-center overflow-hidden">
      <div className="mb-6">
        <img src="https://res.cloudinary.com/dk0nzszcz/image/upload/v1746929146/cantrysa-logo_rsl063.png" className="h-auto w-auto"/>
      </div>
      <p className="text-2xl font-montserrat text-text animate-pulse">Saddling up your experience...</p>
    </div>
  );
}